import { render, staticRenderFns } from "./hanging_man.vue?vue&type=template&id=7099b056"
import script from "./hanging_man.vue?vue&type=script&lang=js"
export * from "./hanging_man.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports